import React, { useEffect, useState } from "react";




import userIcon from '../../assets/iconos/usuario.png'
import Lupita from '../../assets/iconos/lupa.png'

import ChatAccordion from "./ChatAccordion.jsx";
import Contacts from "./Contacts";

import { getMessages, readMessage, getSentMessages } from '../../Services/Inbox.js';

/*Open/Close*/




function Convos(prop){

    const [active,setActive] = useState(false);
    const [messages, setMessages] = useState(null);
    
    const activateNav = () => {
            setActive (!active)        
    }

    const loadMessages = async () => {
        let rsp = await getMessages();

        if(rsp.Error == false && rsp.Data.length > 0){
            setMessages(rsp.Data);
        }
    }

    const loadSentMessages = async () => {
        let rsp = await getSentMessages();

        if(rsp.Error == false && rsp.Data.length > 0){
            setMessages(rsp.Data);
        }
    }

    const openMessage = async (item) => {
        if(item.is_read == false){
            await readMessage(item.id);
        }

        prop.setContact({send: false, ...item});
    }

    useEffect(() => {
        loadMessages();
    }, []);
    
    

    return(
        <>
        <div className="" > 
            <div className="">
                <div>
                    <div>
                        <div className='contact-options'>
                            <button className="green-btn setpointer sethoverdark" onClick={loadMessages}>Recibidos</button>
                            <button className="green-btn setpointer sethoverdark" onClick={loadSentMessages}>Enviados</button>
                            <button className="green-btn setpointer sethoverdark" onClick={ () => {prop.changeNav()}}>Contactos</button>
                        </div>
                    </div>
                
                </div>
            </div>
        </div>
        {
            messages != null ?
            messages.map((item) => {
                return(
                    <div key={item.id + 'idm'} className="messagePreview" onClick={() => openMessage(item)}>
                        {/*TODO AGREGAR IMAGEN */}
                        <h5>{item.name}</h5>
                        <h6>{item.subject} {item.is_read ? '(Leido)' : ''}</h6>
                        <h6>{item.date}</h6>
                    </div>
                );
            })
            :
            <></>
        }
        </>
    );
}


export default Convos
